import { render, staticRenderFns } from "./DocBox.vue?vue&type=template&id=240322aa&scoped=true&"
import script from "./DocBox.vue?vue&type=script&lang=js&"
export * from "./DocBox.vue?vue&type=script&lang=js&"
import style0 from "./DocBox.vue?vue&type=style&index=0&id=240322aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "240322aa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('240322aa')) {
      api.createRecord('240322aa', component.options)
    } else {
      api.reload('240322aa', component.options)
    }
    module.hot.accept("./DocBox.vue?vue&type=template&id=240322aa&scoped=true&", function () {
      api.rerender('240322aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-25Grx6LyxZsZ0/JS/comp/DocBox.vue"
export default component.exports